//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { eventEmitter } from "@/main.js";
import { mapGetters, mapActions } from "vuex";
import lodash from "lodash";
export default {
	name: "note-tile",
	props: {
		tileKey: {
			type: String,
			required: true,
		},
		tileProps: {
			type: String,
			required: true,
		},
	},
	data: () => ({
		data: [],
		editor: "",
		loading: false,
	}),
	methods: {
		...mapActions(["updateObject", "deleteTile"]),

		async update() {
			try {
				this.loading = true;
				console.log("Sync note text");
				await this.updateObject({ text: this.editor, id: this.key });
			} catch (e) {
				this.loading = false;
				console.warn("Error while executing NOTE request", e);
			} finally {
				this.loading = false;
			}
		},

		removeTile() {
			this.deleteTile(this.key);
		},
	},
	watch: {
		tileProps: {
			immediate: true,
			async handler(val) {},
		},
	},
	created() {
		this.debounce = lodash.debounce(this.update, 5000);
	},
	mounted() {
		this.editor = this.tileProps;
	},
	watch: {
		editor(text) {
			this.debounce();
		},
	},

	computed: {
		key() {
			return this.tileKey;
		},
	},
};
